import { noop } from 'lodash'
import React from 'react'

import { IFilterType } from '../../../../types'
import CheckboxType from './CheckboxType'
import DaterangeType from './DaterangeType'
import FulltextType from './FulltextType'
import MultivalueType from './MultivalueType'
import { SelectType } from './SelectType'
import ThreesidedType from './ThreesidedType'

const FilterType = (props: IFilterType): React.ReactElement => {
  const { filter = {}, isMobile, index, handleKeyDown = noop } = props

  if (filter.type === 'component') {
    return filter.component
  }
  if (
    filter.type === 'value' ||
    (filter.type === 'fulltext' && filter.exludeForDetail)
  ) {
    return (
      <FulltextType
        filter={filter}
        isMobile={isMobile}
        index={index}
        handleKeyDown={handleKeyDown}
      />
    )
  }
  if (filter.type === 'checkbox') {
    return <CheckboxType filter={filter} index={index} />
  }

  if (filter.type === 'multiValue') {
    return <MultivalueType filter={filter} index={index} />
  }

  if (filter.type === 'threeSidedBoolean') {
    return <ThreesidedType filter={filter} index={index} />
  }

  if (filter.type === 'daterange') {
    return <DaterangeType filter={filter} index={index} />
  }

  if (filter.type === 'select') {
    return <SelectType filter={filter} index={index} />
  }

  return <></>
}

export default FilterType
